import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { PageAboutUsComponent } from "./pages/page-about-us/page-about-us.component";
import { PageHomeComponent } from "./pages/page-home/page-home.component";
import { ViewPublicVacanciesComponent } from "./public/view-public-vacancies/view-public-vacancies.component";
import { PageTermsAndConditionsComponent } from "./pages/page-terms-and-conditions/page-terms-and-conditions.component";
import { PagePrivacyStatementComponent } from "./pages/page-privacy-statement/page-privacy-statement.component";
import { PageLostPasswordComponent } from "./pages/page-lost-password/page-lost-password.component";
import { PageProjectsComponent } from "./pages/page-projects/page-projects.component";
import { PageVideosComponent } from "./pages/page-videos/page-videos.component";
import { PageBlogComponent } from "./pages/page-blog/page-blog.component";
import { PageExplanationPlatformComponent } from "./pages/page-explanation-platform/page-explanation-platform.component";
import { PageIAmAStudentComponent } from "./pages/page-i-am-a-student/page-i-am-a-student.component";
import { PageIAmACompanyComponent } from "./pages/page-i-am-a-company/page-i-am-a-company.component";
import { PageProjectComponent } from "./pages/page-projects/page-project/page-project.component";
import { PageEventComponent } from "./pages/page-events/page-event/page-event.component";
import { PageBlogPostComponent } from "./pages/page-blog/page-blog-post/page-blog-post.component";
import { PageVideoComponent } from "./pages/page-videos/page-video/page-video.component";
import { StudentSettingsComponent } from "./student/student-settings/student-settings.component";
import { CompanyProfilePublicComponent } from "./companies/company-profile-public/company-profile-public.component";
import { StudentCompanySearchComponent } from "./student/student-company-search/student-company-search.component";
import { JobProfileComponent } from "./jobs/job-profile/job-profile.component";
import { StudentApplicationsComponent } from "./student/student-applications/student-applications.component";
import { StudentJobsComponent } from "./student/student-jobs/student-jobs.component";
import { RegisterComponent } from "./authentication/register/register.component";
import { StudentRegistrationComponent } from "./student/student-registration/student-registration.component";
import { CompanyProfileComponent } from "./company/company-profile/company-profile.component";
import { RoleGuard } from "./guards/role.guard";
import { AuthGuard } from "./guards/auth.guard";
import { CapabilityGuard } from "./guards/capability.guard";
import { RoleTypes, ADMIN_ROLES } from "./guards/roletypes";
import { CompanyApplicationsComponent } from "./company/company-applications/company-applications.component";
import { CompanyStudentsComponent } from "./company/company-students/company-students.component";
import { CompanyStudentProfileComponent } from "./company/company-student-profile/company-student-profile.component";
import { TeacherRegistrationComponent } from "./teacher/teacher-registration/teacher-registration.component";
import { ProfileComponent } from "./profile/profile.component";
import { AdminComponent } from "./admin/admin.component";
import { AdminDashboardComponent } from "./admin/admin-dashboard/admin-dashboard.component";
import { PublicLayoutComponent } from "./layout/layout.component";
import { AdminFieldofinterestComponent } from "./admin/admin-fieldofinterest/admin-fieldofinterest.component";
import { AdminTagsComponent } from "./admin/admin-tags/admin-tags.component";
import { AdminStudentprofilesComponent } from "./admin/admin-studentprofiles/admin-studentprofiles.component";
import { AdminBlogpostsComponent } from "./admin/admin-blogposts/admin-blogposts.component";
import { AdminEventsComponent } from "./admin/admin-events/admin-events.component";
import { AdminEducationLevelsComponent } from "./admin/admin-education-levels/admin-education-levels.component";
import { AdminProjectsComponent } from "./admin/admin-projects/admin-projects.component";
import { AdminEducationsComponent } from "./admin/admin-educations/admin-educations.component";
import { AdminCompanypagesComponent } from "./admin/admin-companypages/admin-companypages.component";
import { AdminAccountsComponent } from "./admin/admin-accounts/admin-accounts.component";
import { AdminMatchtestComponent } from "./admin/admin-matchtest/admin-matchtest.component";
import { AdminCompaniesComponent } from "./admin/admin-companies/admin-companies.component";
import { AdminJobsComponent } from "./admin/admin-jobs/admin-jobs.component";
import { ErrorForbiddenComponent } from "./errors/error-forbidden/error-forbidden.component";
import { AdminSchoolsComponent } from "./admin/admin-schools/admin-schools.component";
import { AdminSchoolClassesComponent } from "./admin/admin-schools/admin-school-classes/admin-school-classes.component";
import { CompanyAccountComponent } from "./company/company-account/company-account.component";
import { AdminTeacherprofilesComponent } from "./admin/admin-teacherprofiles/admin-teacherprofiles.component";
import { AdminExternalpageComponent } from "./admin/admin-externalpages/admin-externalpage/admin-externalpage.component";
import { AdminVideosComponent } from "./admin/admin-videos/admin-videos.component";
import { AdminTestimonialsComponent } from "./admin/admin-testimonials/admin-testimonials.component";
import { AdminPagesComponent } from "./admin/admin-pages/admin-pages.component";
import { AccountComponent } from "./account/account.component";
import { PageComponent } from "./pages/page/page.component";
import { ErrorNotfoundComponent } from "./errors/error-notfound/error-notfound.component";
import { ParentalconsentComponent } from "./authentication/parentalconsent/parentalconsent.component";
import { AdminExternalpageSchoolsComponent } from "./admin/admin-externalpage-schools/admin-externalpage-schools.component";
import { AssignmentProfileComponent } from "./jobs/assignment-profile/assignment-profile.component";
import { StudentExperiencedaysComponent } from "./student/student-experiencedays/student-experiencedays.component";
import { AdminMeetdaysComponent } from "./admin/admin-meetdays/admin-meetdays.component";
import { MeetdaySignupComponent } from "./student/meetday-signup/meetday-signup.component";
import { MeetdayAttendanceConfirmationComponent } from "./meetday/meetday-attendance-confirmation/meetday-attendance-confirmation.component";
import { PublicStudentCurrentDnaComponent } from "./student/public/public-student-current-dna/public-student-current-dna.component";
import { AdminExperienceDaysComponent } from "./admin/admin-experience-days/admin-experience-days.component";
import { AdminToolsComponent } from "./admin/admin-tools/admin-tools.component";
import { AdminCompanyAccountsComponent } from "./admin/admin-companies/admin-company-accounts/admin-company-accounts.component";
import { marker } from "@biesbjerg/ngx-translate-extract-marker";
import { TransferRijrComponent } from "./transfer-rijr/transfer-rijr.component";
import { PageEventsComponent } from "./pages/page-events/page-events.component";
import { PageContactComponent } from "./pages/page-contact/page-contact.component";
import { AdminPostsComponent } from "./admin/admin-posts/admin-posts.component";
import { PagePostsComponent } from "./pages/page-posts/page-posts.component";
import { PagePostComponent } from "./pages/page-posts/page-post/page-post.component";
import { CompanyApplicationComponent } from "./company/company-applications/company-application/company-application.component";
import { PageSchoolComponent } from "./pages/page-schools/page-school/page-school.component";
import { StudentResumeComponent } from "./student/student-resume/student-resume.component";
import { CallForOpportunitiesComponent } from "./shared/components/sections/call-for-opportunities/call-for-opportunities.component";

const routes: Routes = [
  {
    path: "",
    component: PublicLayoutComponent,
    data: {},
    children: [
      {
        path: "",
        component: PageHomeComponent,
        data: {
          title: "Home",
          metaDescription:
            "Meet the Youngsters verbindt studenten en bedrijven. Ontdek unieke carrièremogelijkheden en stimuleer jouw talent bij topbedrijven in Limburg en de Euregio",
          metaKeywords:
            "Meet the Youngsters, studenten, bedrijven, Limburg, stages, carrière, banen, projecten, talentontwikkeling, werkgevers, onderwijs, evenementen, jongeren, netwerken, euregio, Belgisch Limburg",
          metaDescriptionEn:
            "Meet the Youngsters connects students and companies. Discover unique career opportunities and stimulate your talent at top companies in Limburg and the Euregio",
          metaKeywordsEn:
            "Meet the Youngsters, students, companies, Limburg, internships, career, jobs, projects, talent development, employers, education, events, young people, networking, Euregio, Belgian Limburg",
          metaDescriptionDe:
            "Meet the Youngsters verbindet Studierende und Unternehmen. Entdecken Sie einzigartige Karrieremöglichkeiten und fördern Sie Ihr Talent bei Top-Unternehmen in Limburg und der Euregio",
          metaKeywordsDe:
            "Treffen Sie die Jugendlichen, Studenten, Unternehmen, Limburg, Praktika, Karriere, Jobs, Projekte, Talententwicklung, Arbeitgeber, Bildung, Veranstaltungen, junge Leute, Netzwerke, Euroregion, Belgisches Limburg",
          metaDescriptionPt:
            "Meet the Youngsters conecta estudantes e empresas. Descubra oportunidades de carreira únicas e desenvolva o seu talento em empresas de destaque em Limburg e na Euregio",
          metaKeywordsPt:
            "Meet the Youngsters, estudantes, empresas, Limburg, estágios, carreira, empregos, projetos, desenvolvimento de talentos, empregadores, educação, eventos, jovens, networking, euregio, Limburg belga",
        },
      },
      {
        path: "about-us",
        component: PageAboutUsComponent,
        data: {
          title: "About us",
          metaDescription: "",
          metaKeywords: "",
          metaDescriptionEn: "",
          metaKeywordsEn: "",
          metaDescriptionDe: "",
          metaKeywordsDe: "",
          metaDescriptionPt: "",
          metaKeywordsPt: "",
        },
      },
      {
        path: "lost-password",
        component: PageLostPasswordComponent,
        data: { title: "Lost password" },
      },
      {
        path: "privacy-statement",
        component: PagePrivacyStatementComponent,
        data: { title: "Privacy statement" },
      },
      {
        path: "terms-and-conditions",
        component: PageTermsAndConditionsComponent,
        data: { title: "Terms and conditions" },
      },
      {
        path: "our-network",
        loadComponent: () =>
          import(
            "./public/view-public-our-network/view-public-our-network.component"
          ).then((m) => m.ViewPublicOurNetworkComponent),
        data: {
          title: "Our network",
          metaDescription:
            "Ontdek het netwerk van Meet the Youngsters: een samenwerking met toonaangevende bedrijven en organisaties in Limburg en de Euregio. Bouw waardevolle connecties op en versterk jouw toekomst door deelname aan ons uitgebreide netwerk.",
          metaKeywords:
            "Meet the Youngsters netwerk, bedrijvennetwerk, Zuid-Limburg, Midden-Limburg, Noord-Limburg, Limburg, België, connecties, bedrijfsrelaties, partners, samenwerking, bedrijven, studenten, netwerken",
          metaDescriptionEn:
            "Discover the network of Meet the Youngsters: a collaboration with leading companies and organisations in Limburg and the Euregio. Build valuable connections and strengthen your future by participating in our extensive network.",
          metaKeywordsEn:
            "Meet the Youngsters network, business network, South Limburg, Central Limburg, North Limburg, Limburg, Belgium, connections, business relations, partners, collaboration, companies, students, networks",
          metaDescriptionDe:
            "Entdecken Sie das Netzwerk Meet the Youngsters: eine Zusammenarbeit mit führenden Unternehmen und Organisationen in Limburg und der Euregio. Bauen Sie wertvolle Verbindungen auf und stärken Sie Ihre Zukunft, indem Sie an unserem umfangreichen Netzwerk teilnehmen.",
          metaKeywordsDe:
            "Lernen Sie das Youngsters-Netzwerk kennen, ein Geschäftsnetzwerk, Süd-Limburg, Mittel-Limburg, Nord-Limburg, Limburg, Belgien, Verbindungen, Geschäftsbeziehungen, Partner, Zusammenarbeit, Unternehmen, Studenten, Netzwerke",
          metaDescriptionPt:
            "Descubra a rede do Meet the Youngsters: uma colaboração com empresas e organizações líderes em Limburg e na Euregio. Construa conexões valiosas e fortaleça o seu futuro participando da nossa ampla rede.",
          metaKeywordsPt:
            "rede Meet the Youngsters, rede empresarial, Sul de Limburg, Centro de Limburg, Norte de Limburg, Limburg, Bélgica, conexões, relações empresariais, parceiros, colaboração, empresas, estudantes, networking",
        },
      },
      {
        path: "international",
        loadComponent: () =>
          import("./pages/landing/international.component").then(
            (m) => m.InternationalComponent
          ),
        data: {
          title: "Internationals",
          metaDescription:
            "Ontdek bedrijven die op zoek zijn naar internationaal talent. Maak een gratis profiel aan en begin met het verbinden met werkgevers in de regio.",
          metaDescriptionEn:
            "Discover companies looking for international talent. Create your free profile and start connecting with employers in the region.",
          metaDescriptionDe:
            "Entdecken Sie Unternehmen, die nach internationalen Talenten suchen. Erstellen Sie ein kostenloses Profil und vernetzen Sie sich mit Arbeitgebern in der Region.",
          metaDescriptionPt:
            "Descubra empresas que procuram talentos internacionais. Crie seu perfil gratuito e comece a se conectar com empregadores da região.",
        },
      },
      {
        path: "internationals",
        redirectTo: "international",
        pathMatch: "full",
      },
      {
        path: "pupil",
        loadComponent: () =>
          import("./pages/landing/pupil.component").then(
            (m) => m.PupilComponent
          ),
        pathMatch: "full",
        data: { title: "Pupil" },
      },
      {
        path: "student",
        loadComponent: () =>
          import("./pages/landing/student.component").then(
            (m) => m.StudentComponent
          ),
        pathMatch: "full",
        data: { title: "Student" },
      },
      {
        path: "young-professional",
        loadComponent: () =>
          import("./pages/landing/young-professional.component").then(
            (m) => m.YoungProfessionalComponent
          ),
        pathMatch: "full",
        data: { title: "Young Professional" },
      },
      {
        path: "professional",
        loadComponent: () =>
          import("./pages/landing/professional.component").then(
            (m) => m.ProfessionalComponent
          ),
        pathMatch: "full",
        data: { title: "Professional" },
      },
      {
        path: "teacher",
        loadComponent: () =>
          import("./pages/landing/teacher.component").then(
            (m) => m.TeacherComponent
          ),
        pathMatch: "full",
        data: { title: "Teacher" },
      },
      {
        path: "company",
        loadComponent: () =>
          import("./pages/landing/company.component").then(
            (m) => m.CompanyComponent
          ),
        pathMatch: "full",
        data: { title: "Company" },
      },
      {
        path: "meet-chill",
        loadComponent: () =>
          import("./pages/landing/meet-chill.component").then(
            (m) => m.MeetChillComponent
          ),
        data: {
          title: "Meet CHILL",
          metaDescription:
            "Ontdek bedrijven die op zoek zijn naar internationaal talent. Maak een gratis profiel aan en begin met het verbinden met werkgevers in de regio.",
          metaDescriptionEn:
            "Discover companies looking for international talent. Create your free profile and start connecting with employers in the region.",
          metaDescriptionDe:
            "Entdecken Sie Unternehmen, die nach internationalen Talenten suchen. Erstellen Sie ein kostenloses Profil und vernetzen Sie sich mit Arbeitgebern in der Region.",
          metaDescriptionPt:
            "Descubra empresas que procuram talentos internacionais. Crie seu perfil gratuito e comece a se conectar com empregadores da região.",
        },
      },
      {
        path: "vacancies",
        component: ViewPublicVacanciesComponent,
        data: {
          title: "Vacancies",
          metaDescription:
            "Bekijk de nieuwste vacatures bij topbedrijven in Limburg en België via Meet the Youngsters. Ontdek kansen op stages, startersbanen en projecten die perfect aansluiten bij jouw opleiding en interesses.",
          metaKeywords:
            "Meet the Youngsters vacatures, banen, Zuid-Limburg, Midden-Limburg, Noord-Limburg, Limburg, stages, startersbanen, loopbaan, werkgelegenheid, carrièremogelijkheden, bedrijven, studenten, werk zoeken",
          metaDescriptionEn:
            "Check out the latest vacancies at top companies in Limburg and Belgium via Meet the Youngsters. Discover opportunities for internships, starter jobs and projects that perfectly match your education and interests.",
          metaKeywordsEn:
            "Meet the Youngsters vacancies, jobs, South Limburg, Central Limburg, North Limburg, Limburg, internships, starter jobs, career, employment, career opportunities, companies, students, job search",
          metaDescriptionDe:
            "Sehen Sie sich über Meet the Youngsters die neuesten Stellenangebote bei Top-Unternehmen in Limburg und Belgien an. Entdecken Sie Möglichkeiten für Praktika, Einstiegsjobs und Projekte, die perfekt zu Ihrer Ausbildung und Ihren Interessen passen.",
          metaKeywordsDe:
            "Stellenangebote von Meet the Youngsters, Jobs, Süd-Limburg, Mittel-Limburg, Nord-Limburg, Limburg, Praktika, Einstiegsjobs, Karriere, Beschäftigung, Karrieremöglichkeiten, Unternehmen, Studenten, auf der Suche nach Arbeit",
          metaDescriptionPt:
            "Veja as vagas mais recentes em empresas de destaque em Limburg e na Bélgica através do Meet the Youngsters. Descubra oportunidades de estágios, vagas para iniciantes e projetos que combinam com a sua formação e interesses.",
          metaKeywordsPt:
            "vagas Meet the Youngsters, empregos, Sul de Limburg, Centro de Limburg, Norte de Limburg, Limburg, estágios, primeiros empregos, carreira, emprego, oportunidades de carreira, empresas, estudantes, procurar trabalho",
        },
      },
      {
        path: "experiencedays",
        component: StudentExperiencedaysComponent,
        canActivate: [AuthGuard, CapabilityGuard],
        data: {
          title: "Experience days",
          capability: "canViewFollowUpDays",
        },
      },
      {
        path: "pages/contact",
        component: PageContactComponent,
        data: { title: "Contact" },
      },
      {
        path: "pages/:id",
        component: PageComponent,
        data: { title: "Project" },
      },
      {
        path: "projects",
        component: PageProjectsComponent,
        data: {
          title: "Projects",
          metaDescription:
            "Verken uitdagende projecten bij Meet the Youngsters. Werk samen met bedrijven en ontwikkel je vaardigheden door deel te nemen aan praktijkgerichte projecten in diverse sectoren.",
          metaKeywords:
            "Meet the Youngsters projecten, studentenprojecten, praktijkervaring, bedrijven, Limburg, samenwerking, vaardigheden ontwikkelen, praktijkgerichte projecten, kansen",
          metaDescriptionEn:
            "Explore challenging projects at Meet the Youngsters. Collaborate with companies and develop your skills by participating in practical projects in various sectors.",
          metaKeywordsEn:
            "Meet the Youngsters projects, student projects, practical experience, companies, Limburg, collaboration, developing skills, practical projects, opportunities",
          metaDescriptionDe:
            "Entdecken Sie herausfordernde Projekte bei Meet the Youngsters. Arbeiten Sie mit Unternehmen zusammen und entwickeln Sie Ihre Fähigkeiten durch die Teilnahme an praxisorientierten Projekten in verschiedenen Branchen.",
          metaKeywordsDe:
            "Treffen Sie die Youngsters-Projekte, Studentenprojekte, praktische Erfahrungen, Unternehmen, Limburg, Zusammenarbeit, Kompetenzentwicklung, praxisorientierte Projekte, Möglichkeiten",
          metaDescriptionPt:
            "Explore projetos desafiadores no Meet the Youngsters. Colabore com empresas e desenvolva suas habilidades participando de projetos práticos em diversos setores.",
          metaKeywordsPt:
            "projetos Meet the Youngsters, projetos estudantis, experiência prática, empresas, Limburg, colaboração, desenvolvimento de habilidades, projetos práticos, oportunidades",
        },
      },
      {
        path: "projects/:id",
        component: PageProjectComponent,
        data: { title: "Project" },
      },
      {
        path: "call-for-opportunities",
        component: CallForOpportunitiesComponent,
        data: {
          title: "Announcements",
          metaDescription:
            "Browse student announcements looking for internships, jobs, and opportunities at Meet the Youngsters. Connect with talented students in Limburg and Belgium.",
          metaKeywords:
            "student opportunities, internships, jobs, Meet the Youngsters, students, Limburg, Belgium, career opportunities",
        },
      },
      {
        path: "events",
        component: PageEventsComponent,
        data: {
          title: "Events",
          metaDescription:
            "Ontdek de aankomende evenementen van Meet the Youngsters en maak kennis met bedrijven in Limburg en Belgisch Limburg. Neem deel aan workshops, netwerkbijeenkomsten en carrière-evenementen die jouw toekomst een boost geven.",
          metaKeywords:
            "Meet the Youngsters evenementen, Zuid-Limburg, Midden-Limburg, Noord-Limburg, Limburg, workshops, netwerkbijeenkomsten, carrière-evenementen, studenten, bedrijven, netwerken, toekomst, carrièreontwikkeling",
          metaDescriptionEn:
            "Discover upcoming Meet the Youngsters events and meet companies in Limburg and Belgian Limburg. Participate in workshops, networking events and career events that will boost your future.",
          metaKeywordsEn:
            "Meet the Youngsters events, South Limburg, Central Limburg, North Limburg, Limburg, workshops, networking events, career events, students, companies, networking, future, career development",
          metaDescriptionDe:
            "Entdecken Sie die kommenden Veranstaltungen von Meet the Youngsters und lernen Sie Unternehmen in Limburg und im belgischen Limburg kennen. Nehmen Sie an Workshops, Networking-Events und Karriereveranstaltungen teil, die Ihre Zukunft voranbringen.",
          metaKeywordsDe:
            "Meet The Youngsters Veranstaltungen, Mittel-Limburg, Nord-Limburg, Limburg, Workshops, Netzwerktreffen, Karriereveranstaltungen, Studenten, Unternehmen, Networking, Zukunft, Karriereentwicklung",
          metaDescriptionPt:
            "Descubra os próximos eventos do Meet the Youngsters e conheça empresas em Limburg e no Limburg belga. Participe em workshops, encontros de networking e eventos de carreira que impulsionam o seu futuro.",
          metaKeywordsPt:
            "eventos Meet the Youngsters, Sul de Limburg, Centro de Limburg, Norte de Limburg, Limburg, workshops, networking, eventos de carreira, estudantes, empresas, networking, futuro, desenvolvimento de carreira",
        },
      },
      {
        path: "events/:id",
        component: PageEventComponent,
        data: { title: "Events" },
      },
      {
        path: "videos",
        component: PageVideosComponent,
        data: {
          title: "Videos",
          metaDescription: "",
          metaKeywords: "",
          metaDescriptionEn: "",
          metaKeywordsEn: "",
          metaDescriptionDe: "",
          metaKeywordsDe: "",
          metaDescriptionPt: "",
          metaKeywordsPt: "",
        },
      },
      {
        path: "videos/:id",
        component: PageVideoComponent,
        data: { title: "Video" },
      },
      {
        path: "blog",
        component: PageBlogComponent,
        data: {
          title: "News",
          metaDescription:
            "Blijf op de hoogte van het laatste nieuws en updates van Meet the Youngsters. Ontdek aankomende evenementen, nieuwe samenwerkingen, en kansen voor studenten en bedrijven in Limburg en Belgisch Limburg.",
          metaKeywords:
            "Meet the Youngsters nieuws, updates, evenementen, samenwerkingen, studenten, bedrijven, Zuid-Limburg, Midden-Limburg, Noord-Limburg, Limburg, carrièrekansen, nieuwsberichten, ontwikkelingen",
          metaDescriptionEn:
            "Stay up to date with the latest news and updates from Meet the Youngsters. Discover upcoming events, new collaborations, and opportunities for students and companies in Limburg and Belgian Limburg.",
          metaKeywordsEn:
            "Meet the Youngsters news, updates, events, collaborations, students, companies, South Limburg, Central Limburg, North Limburg, Limburg, career opportunities, news items, developments",
          metaDescriptionDe:
            "Bleiben Sie auf dem Laufenden mit den neuesten Nachrichten und Updates von Meet the Youngsters. Entdecken Sie bevorstehende Veranstaltungen, neue Kooperationen und Möglichkeiten für Studenten und Unternehmen in Limburg und im belgischen Limburg.",
          metaKeywordsDe:
            "Meet the Youngsters-Neuigkeiten, Updates, Veranstaltungen, Kooperationen, Studenten, Unternehmen, Süd-Limburg, Zentral-Limburg, Nord-Limburg, Limburg, Karrieremöglichkeiten, Neuigkeiten, Entwicklungen",
          metaDescriptionPt:
            "Fique por dentro das últimas notícias e atualizações do Meet the Youngsters. Descubra eventos, novas parcerias e oportunidades para estudantes e empresas em Limburg e no Limburg belga.",
          metaKeywordsPt:
            "notícias Meet the Youngsters, atualizações, eventos, parcerias, estudantes, empresas, Sul de Limburg, Centro de Limburg, Norte de Limburg, Limburg, oportunidades de carreira, novidades, desenvolvimentos",
        },
      },
      {
        path: "blog/:id",
        component: PageBlogPostComponent,
        data: { title: "News" },
      },
      { path: "posts", component: PagePostsComponent, data: { title: "Blog" } },
      {
        path: "posts/:id",
        component: PagePostComponent,
        data: { title: "Blog" },
      },
      {
        path: "schools/:id",
        component: PageSchoolComponent,
        data: { title: "School" },
      },
      {
        path: "explanation-platform",
        component: PageExplanationPlatformComponent,
        data: { title: "Explanation Platform" },
      },
      {
        path: "i-am-a-student",
        component: PageIAmAStudentComponent,
        data: { title: "I am a student" },
      },
      {
        path: "i-am-a-company",
        component: PageIAmACompanyComponent,
        data: { title: "I am a company" },
      },
      {
        path: "student/companies",
        component: StudentCompanySearchComponent,
        canActivate: [AuthGuard, RoleGuard],
        data: { title: "Search companies", roles: [RoleTypes.Student] },
      },
      {
        path: "profile",
        component: ProfileComponent,
        canActivate: [AuthGuard, RoleGuard],
        data: {
          title: "Profile",
          roles: [RoleTypes.Student, RoleTypes.Teacher, RoleTypes.Beheerder],
        },
      },
      {
        path: "student/profile",
        redirectTo: "profile",
        pathMatch: "full",
      },
      {
        path: "student/resume",
        component: StudentResumeComponent,
        canActivate: [AuthGuard, RoleGuard],
        data: { title: "Profile", roles: [RoleTypes.Student] },
      },
      {
        path: "student/settings",
        component: StudentSettingsComponent,
        canActivate: [AuthGuard, RoleGuard],
        data: { title: "Settings", roles: [RoleTypes.Student] },
      },
      {
        path: "student/applications",
        component: StudentApplicationsComponent,
        canActivate: [AuthGuard, RoleGuard],
        data: { title: "Applications", roles: [RoleTypes.Student] },
      },
      {
        path: "student/jobfavorites",
        component: StudentApplicationsComponent,
        canActivate: [AuthGuard, RoleGuard],
        data: { title: "Applications", roles: [RoleTypes.Student] },
      },
      {
        path: "student/jobs",
        component: StudentJobsComponent,
        canActivate: [AuthGuard, RoleGuard],
        data: { title: "Jobs", roles: [RoleTypes.Student] },
      },
      {
        path: "student/experiencedays",
        component: StudentExperiencedaysComponent,
        canActivate: [AuthGuard, CapabilityGuard],
        data: {
          title: "Follow-up days",
          capability: "canViewFollowUpDays",
        },
      },
      {
        path: "teacher/profile",
        redirectTo: "profile",
        pathMatch: "full",
      },
      {
        path: "account",
        component: AccountComponent,
        canActivate: [AuthGuard, RoleGuard],
        data: {
          title: "Account",
          roles: [RoleTypes.Company, RoleTypes.Beheerder, RoleTypes.Teacher],
        },
      },
      {
        path: "account/resetpassword",
        component: AccountComponent,
        canActivate: [AuthGuard, RoleGuard],
        data: {
          title: "Account",
          roles: [
            RoleTypes.Company,
            RoleTypes.Beheerder,
            RoleTypes.Student,
            RoleTypes.Teacher,
          ],
        },
      },
      {
        path: "company/account",
        component: CompanyAccountComponent,
        canActivate: [AuthGuard, RoleGuard],
        data: { title: "Account", roles: [RoleTypes.Company] },
      },
      {
        path: "company/applications",
        component: CompanyApplicationsComponent,
        canActivate: [AuthGuard, RoleGuard],
        data: { title: "Applications", roles: [RoleTypes.Company] },
      },
      {
        path: "company/applications/:id",
        component: CompanyApplicationsComponent,
        canActivate: [AuthGuard, RoleGuard],
        data: { title: "Applications", roles: [RoleTypes.Company] },
      },
      {
        path: "jobposting/:jobPostingId/applications/:applicationId",
        component: CompanyApplicationComponent,
        canActivate: [AuthGuard, RoleGuard],
        data: {
          title: "Application",
          roles: [
            RoleTypes.Company,
            RoleTypes.Beheerder,
            RoleTypes.ProfessionalAdmin,
            RoleTypes.InternationalAdmin,
          ],
        },
      },
      {
        path: "company/profile",
        component: CompanyProfileComponent,
        canActivate: [AuthGuard, RoleGuard],
        data: { title: "Profile", roles: [RoleTypes.Company] },
      },
      {
        path: "company/profile/:id",
        component: CompanyProfileComponent,
        canActivate: [AuthGuard, RoleGuard],
        data: {
          title: "Profile",
          roles: [
            RoleTypes.Company,
            RoleTypes.Beheerder,
            RoleTypes.ProfessionalAdmin,
            RoleTypes.InternationalAdmin,
          ],
        },
      },
      {
        path: "company/students",
        component: CompanyStudentsComponent,
        canActivate: [AuthGuard, RoleGuard],
        data: { title: "Candidates", roles: [RoleTypes.Company] },
      },
      {
        path: "company/students/:id",
        component: CompanyStudentProfileComponent,
        canActivate: [AuthGuard, RoleGuard],
        data: {
          title: "Profile",
          roles: [
            RoleTypes.Company,
            RoleTypes.Beheerder,
            RoleTypes.ProfessionalAdmin,
            RoleTypes.InternationalAdmin,
          ],
        },
      },
      {
        path: "company/opportunities",
        component: CallForOpportunitiesComponent,
        canActivate: [AuthGuard, RoleGuard],
        data: { title: "Announcements", roles: [RoleTypes.Company] },
      },
      {
        path: "companies/:id",
        component: CompanyProfilePublicComponent,
        data: { title: "Company profile" },
      },
      {
        path: "companies/:id/:tab",
        component: CompanyProfilePublicComponent,
        data: { title: "Company profile" },
      },
      {
        path: "meetday-attendance/:meetDayId",
        component: MeetdayAttendanceConfirmationComponent,
        data: {
          title: "Meetday Attendance Confirmation",
        },
      },
      {
        path: "jobs/:id",
        component: JobProfileComponent,
        data: { title: "Job" },
      },
      {
        path: "assignments/:id",
        component: AssignmentProfileComponent,
        data: { title: "Assignment" },
      },
      {
        path: "transfer-rijr/:id",
        component: TransferRijrComponent,
        data: { title: marker("Transfer account") },
      },
      {
        path: "errors/403",
        component: ErrorForbiddenComponent,
        data: { title: "Forbidden" },
      },
      {
        path: "errors/404",
        component: ErrorNotfoundComponent,
        data: { title: "Not found" },
      },
      // Authorization paths
      {
        path: "parentalconsent/:id/:token",
        component: ParentalconsentComponent,
        data: { title: "Parental consent" },
      },
      // Subsite redirects
      {
        path: "seriousgame",
        component: PublicLayoutComponent,
        resolve: {
          url: "externalUrlRedirectResolver",
        },
        data: {
          externalUrl: "https://seriousgame.meettheyoungsters.nl",
        },
      },
      {
        path: "zandengrind",
        component: PublicLayoutComponent,
        resolve: {
          url: "externalUrlRedirectResolver",
        },
        data: {
          externalUrl: "https://zandengrind.meettheyoungsters.nl",
        },
      },
      {
        path: "public-cv/:id",
        component: StudentResumeComponent,
        data: {
          title: "Student CV",
        },
      },

      // TEMP PATHS
      {
        path: "meetday/:id",
        component: MeetdaySignupComponent,
        data: { title: "Meet day signup" },
      },
    ],
  },

  // Admin pages
  {
    path: "admin",
    component: AdminComponent,
    canActivate: [AuthGuard, RoleGuard],
    canLoad: [AuthGuard, RoleGuard],
    data: { roles: [...ADMIN_ROLES], title: "Administration" },
    children: [
      {
        path: "",
        component: AdminDashboardComponent,
        data: { roles: [...ADMIN_ROLES], title: "Dashboard" },
      },
      {
        path: "dashboard",
        component: AdminDashboardComponent,
        data: { roles: [...ADMIN_ROLES], title: "Dashboard" },
      },
      {
        path: "fieldofinterest",
        component: AdminFieldofinterestComponent,
        data: { title: "Field of interest" },
      },
      {
        path: "tags",
        component: AdminTagsComponent,
        data: { title: "Tags" },
      },
      {
        path: "studentprofiles",
        component: AdminStudentprofilesComponent,
        data: { title: "Student profiles" },
      },
      {
        path: "studentprofiles/:id",
        component: AdminStudentprofilesComponent,
        data: { title: "Student profiles" },
      },
      {
        path: "teacherprofiles",
        component: AdminTeacherprofilesComponent,
        data: { title: "Teacher profiles" },
      },
      {
        path: "companies",
        component: AdminCompaniesComponent,
        data: { title: "Companies" },
      },
      {
        path: "companies/:id",
        component: AdminCompaniesComponent,
        data: { title: "Companies" },
      },
      {
        path: "company-accounts",
        component: AdminCompanyAccountsComponent,
        data: { title: "Company accounts" },
      },
      { path: "jobs", component: AdminJobsComponent, data: { title: "Jobs" } },
      {
        path: "jobs/:id",
        component: AdminJobsComponent,
        data: { title: "Jobs" },
      },
      {
        path: "blogposts",
        component: AdminBlogpostsComponent,
        data: { title: "News" },
      },
      {
        path: "posts",
        component: AdminPostsComponent,
        data: { title: "Blogs" },
      },
      {
        path: "pages",
        component: AdminPagesComponent,
        data: { title: "Pages" },
      },
      {
        path: "events",
        component: AdminEventsComponent,
        data: { title: "Events" },
      },
      {
        path: "externalpageschools",
        component: AdminExternalpageSchoolsComponent,
        data: { title: "Schools" },
      },
      {
        path: "projects",
        component: AdminProjectsComponent,
        data: { title: "Projects" },
      },
      {
        path: "testimonials",
        component: AdminTestimonialsComponent,
        data: { title: "Testimonials" },
      },
      {
        path: "videos",
        component: AdminVideosComponent,
        data: { title: "Videos" },
      },
      {
        path: "schools",
        component: AdminSchoolsComponent,
        data: { title: "Schools" },
      },
      {
        path: "schools/:schoolId/classes",
        component: AdminSchoolClassesComponent,
        data: { title: "School Classes" },
      },
      {
        path: "educationlevels",
        component: AdminEducationLevelsComponent,
        data: { title: "Education levels" },
      },
      {
        path: "educations",
        component: AdminEducationsComponent,
        data: { title: "Educations" },
      },
      {
        path: "companypages",
        component: AdminCompanypagesComponent,
        data: { title: "Company pages" },
      },
      {
        path: "matchtest",
        component: AdminMatchtestComponent,
        data: { title: "Match test" },
      },
      {
        path: "accounts",
        component: AdminAccountsComponent,
        data: { title: "Accounts" },
      },
      {
        path: "externalpage",
        component: AdminExternalpageComponent,
        data: { title: "External page" },
      },
      {
        path: "externalpage/:pageType",
        component: AdminExternalpageComponent,
        data: { title: "External page" },
      },
      {
        path: "externalpage/:pageType/:id",
        component: AdminExternalpageComponent,
        data: { title: "External page" },
      },
      {
        path: "externalpage/:pageType/duplicate/:id",
        component: AdminExternalpageComponent,
        data: { title: "Duplicate External page" },
      },
      {
        path: "meetdays",
        component: AdminMeetdaysComponent,
        data: { title: "Meet days" },
      },
      {
        path: "experiencedays",
        component: AdminExperienceDaysComponent,
        data: { title: "Follow-up days" },
      },
      {
        path: "tools",
        component: AdminToolsComponent,
        data: { title: "Tools" },
      },
    ],
  },
  // Registration paths
  {
    path: "registreren",
    loadComponent: () =>
      import("./pages/landing/register.component").then(
        (m) => m.LandingRegisterComponent
      ),
    data: { title: "Register" },
  },
  {
    path: "chill",
    loadComponent: () =>
      import("./pages/landing/register-chill.component").then(
        (m) => m.RegisterChillComponent
      ),
    data: { title: "Meet the Youngsters × CHILL" },
  },
  {
    path: "register",
    component: RegisterComponent,
    data: { title: "Register" },
  },
  {
    path: "student/registration",
    component: StudentRegistrationComponent,
    data: { title: "Register" },
  },
  {
    path: "teacher/registration",
    component: TeacherRegistrationComponent,
    data: { title: "Register" },
  },
  {
    path: "public/student/:id/dna/current",
    component: PublicStudentCurrentDnaComponent,
    data: { title: "Student DNA" },
  },

  // Root-level catch-all route for single-segment URLs
  {
    path: ":id",
    component: PublicLayoutComponent,
    data: { title: "Page" },
    children: [{ path: "", component: PageComponent, data: { title: "Page" } }],
  },

  // Wildcard route - redirects all unmatched URLs to 404
  {
    path: "**",
    redirectTo: "errors/404",
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: "top" })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
